import React, { type FC } from "react";
import { useApiCall } from "../api/api";
import type { InspectionPhoto } from "../api/dto/InspectionPhoto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const DeletePhotoModal: FC<{ photo: InspectionPhoto; onFinished?: () => void }> = (
  props,
) => {
  const { deletePhoto } = useApiCall();

  const save = async () => {
    await deletePhoto(props.photo.inspectionId, props.photo.id);
    props.onFinished?.();
  };
  return (
    <div>
      <p>
        <strong>Let op!</strong> Weet je zeker dat deze foto wilt verwijderen?
      </p>
      <p>
        Dit is een <strong>permanente</strong> actie en kan niet ongedaan worden gemaakt.
      </p>
      <ModalFooter text={"Verwijderen"} onSubmit={save} />
    </div>
  );
};
